import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { BeltAnalytics, DataIntervalTag, fragQuery } from '@models';
import { FragQueryService } from 'src/injectables/frag-query.service';
import { op } from '@lib/rxjs';
import { formatDuration } from '@app/new-ui/analysis/analysis.component';
@Component({
    selector: 'live-tag-details',
    templateUrl: './live-tag-details.component.html',
    styleUrls: ['./live-tag-details.component.scss']
})
export class LiveTagDetailsComponent {

    constructor(
        private readonly router: Router,
        private readonly fragQuery: FragQueryService
    ) { }

    @Input()
    get tags() {
        return this.tags$.value;
    }
    set tags(v) {
        this.tags$.next(v ?? []);
    }

    private subscriptions: Subscription = new Subscription();
    private readonly tags$ = new BehaviorSubject<DataIntervalTag[]>([]);
    public readonly particleSizeUnitSystem$ = this.fragQuery.particleSizeUnitSystem$;
    public isConveyor: boolean = false
    public beltAnalytics: BeltAnalytics = {
        upBelt: {
            time: '---',
            percentage: 0,
        },
        offBelt: {
            time: '---',
            percentage: 0,
        },
        blackBelt: {
            time: '---',
            percentage: 0,
        }
    }

    ngOnInit() {
        this.subscriptions.add(this.fragQuery.device$.subscribe(device => {
            if (device)
                this.isConveyor = device.type === 'conveyor';
        }))

        this.subscriptions.add(this.fragQuery.timelineSieveSizesAtPercents$.subscribe(input => {
            this._calculateBeltTimeMetrics(input);
        }))
    }

    private _calculateBeltTimeMetrics(input: fragQuery.timeline.sieveSizesAtPercents.Response): void {
        const totalTime = input?.totalTime || 0;
        const offBeltDuration = input?.offBeltDuration || 0;
        const blackBeltDuration = input?.blackBeltDuration || 0;

        this.beltAnalytics = {
            upBelt: {
                time: formatDuration(totalTime - offBeltDuration - blackBeltDuration),
                percentage: input?.efficiency ?? 0,
            },
            offBelt: {
                time: formatDuration(offBeltDuration),
                percentage: +(100 * offBeltDuration / totalTime).toFixed(2) || 0,
            },
            blackBelt: {
                time: formatDuration(blackBeltDuration),
                percentage: +(100 * blackBeltDuration / totalTime).toFixed(2) || 0,
            }
        }
    }

    isSmallScreen(): boolean {
        return window.innerWidth <= 780;
    }

    switchPage() {
        this.router.navigateByUrl(`/details`);
    }

    public readonly benchHeight$ = this.tags$.pipe(
        map(tags => tags
            .filter(tag => tag.benchHeightSize !== null && tag.benchHeightSize !== undefined)
            .map(tag => tag.benchHeightSize)
        )
    );

    public readonly benchSeam$ = this.tags$.pipe(
        map(tags => tags
            .filter(tag => tag.benchSeam !== null && tag.benchSeam !== undefined)
            .map(tag => tag.benchSeam)
        )
    );

    public ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }


    public readonly tag$ = {
        benchHeight:
            this.tags$.pipe(
                op.map(tags => {
                    let i = tags.find(tag => tag.benchHeightSize !== null) || null;
                    if (i) {
                        return i.benchHeightSize;
                    } else {
                        return 0;
                    }
                }),
            ),
        benchSeamSize:
            this.tags$.pipe(
                op.map(tags => {
                    let i = tags.find(tag => tag.benchSeamSize !== null) || null;
                    if (i) {
                        return i.benchSeamSize;
                    } else {
                        return 0;
                    }
                }),
            ),
        materialType: this.tags$.pipe(op.map(tags => tags.map(tag => tag.materialType ?? '---').unique().join(', ') || '---')),
        truckLoadCount: this.tags$.pipe(op.map(tags => tags.map(tag => tag.truckLoadCount ?? '---').unique().join(', ') || '---')),
        comments: this.tags$.pipe(op.map(tags => tags.map(tag => tag.comments ?? '---').unique().join(', ') || '---')),
    };
}
